import React from "react"
import styled from "@emotion/styled"
import AnchorLink from "react-anchor-link-smooth-scroll"

const Container = styled(AnchorLink)`
  width: 100%;
  border: none;
  border-radius: ${props => props.theme.radius.xl};
  background-color: ${props => props.theme.shade[100]};
  padding: 12px 32px;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  border-radius: 32px;
  font-weight: 600;
  display: block;
  background-color: ${props =>
    props.buttonStyle === "ghost"
      ? "transparent"
      : props.buttonStyle === "inverted"
      ? props.theme.shade[100]
      : props.backgroundColorOverride};
  color: ${props =>
    props.buttonStyle === "ghost"
      ? props.backgroundColorOverride
      : props.buttonStyle === "inverted"
      ? props.backgroundColorOverride
      : props.theme.shade[100]};
  border: solid 1px
    ${props =>
      props.buttonStyle === "ghost"
        ? props.backgroundColorOverride
        : props.buttonStyle === "inverted"
        ? "transparent"
        : "transparent"};
`

export default function ButtonAnchor({
  children,
  buttonStyle,
  backgroundColorOverride,
  href,
}) {
  return (
    <Container
      buttonStyle={buttonStyle}
      backgroundColorOverride={backgroundColorOverride}
      href={href}
    >
      {children}
    </Container>
  )
}
